import(/* webpackMode: "eager" */ "/vercel/path0/app/ressurser/lonnskalkulator/page.tsx");
